import { PropertyType } from '../../../common';

export const mapApiToEntity = (data: PropertyType): PropertyType => {
	return {
		gameCategory: data.data,
	};
};

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
	category_id: data.id,
});
